/**
 * Rct Collapsible Card
 */
import React, { Component, Fragment } from 'react';
import { Collapse, Badge } from 'reactstrap';
import classnames from 'classnames';

// rct section loader
import RctSectionLoader from '../RctSectionLoader/RctSectionLoader';

class RctCollapsibleCard extends Component {

	state = {
		reload: false,
		collapse: true,
		close: false,
		backadd:false,
	}
    

	onCollapse(e) {
		e.preventDefault();
		this.setState({ collapse: !this.state.collapse });
	}

	onReload(e) {
		e.preventDefault();
		this.setState({ reload: true });
		let self = this;
		setTimeout(() => {
			self.setState({ reload: false });
		}, 1500);
	}

	onCloseSection(e) {
		e.preventDefault();
		this.setState({ close: true });
	}

	onRectBackSection(e) {
		// e.preventDefault();
		// this.setState({ editdiv:false, adddiv:true });
		//this.onAddSection();
	}

	render() {
		const { close, reload, collapse, backadd } = this.state;
		const { children, collapsible, closeable, reloadable, heading, fullBlock, colClasses, customClasses, headingCustomClasses, contentCustomClasses, badge, backtoadd, chkbtn, addbtn, listbtn } = this.props;
		return (
			<div className={classnames(colClasses ? colClasses : '', { 'd-block': !collapse })}>
				<div className={classnames(`rct-block ${customClasses ? customClasses : ''}`, { 'd-none': close })}>
					{heading &&
						<div className={`rct-block-title ${headingCustomClasses ? headingCustomClasses : ''}`}>
							<h4>{heading} {badge && <Badge className="p-1 ml-10" color={badge.class}>{badge.name}</Badge>}</h4>
							{(collapsible || reloadable || closeable || backtoadd || addbtn || listbtn) &&
								<div className="contextual-link">
									{collapsible && <a href="#" onClick={(e) => this.onCollapse(e)}><i className="ti-minus"></i></a>}
									{reloadable && <a href="#" onClick={(e) => this.onReload(e)}><i className="ti-reload"></i></a>}
									{closeable && <a href="#" onClick={(e) => this.onCloseSection(e)}><i className="ti-close"></i></a>}
									{backtoadd && <input type="button" className="mr-10 mb-10 btn btn-outline-warning" onClick={this.props.onClick} value="Back" />}
									{chkbtn==1? 
									<>
										{addbtn && <a onClick={this.props.onClickAdd} style={{color:"blue"}}><span class="icon-plus"></span> Add</a>}
										{listbtn && <a style={{color:"orange", paddingLeft:"10px"}} onClick={this.props.onClickList}><span class="icon-list"></span> List</a>}
									</>
									:''}	
									</div>
							}
						</div>
					}
					<Collapse isOpen={collapse}>
						<div className={classnames(contentCustomClasses ? contentCustomClasses : '', { "rct-block-content": !fullBlock, 'rct-full-block': fullBlock })}>
							{children}
						</div>
					</Collapse>
					{reload && <RctSectionLoader />}
				</div>
			</div>
		);
	}
}

export default RctCollapsibleCard;
